import { render, staticRenderFns } from "./itemStatus.vue?vue&type=template&id=ea2a220c&"
import script from "./itemStatus.vue?vue&type=script&lang=js&"
export * from "./itemStatus.vue?vue&type=script&lang=js&"
import style0 from "./itemStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports